// Recognized flag variation types in the LaunchDarkly Client SDK
export enum FlagType {
  JSON = 'json',
  STRING = 'string',
  NUMBER = 'number',
  BOOL = 'bool',
}
